import React, { useRef, useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import icons from "../../../assets/images/constantIcons";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";

export default function Calendar({ staffId }) {
  const calendarRef = useRef(null);
  const [currentDate, setCurrentDate] = useState("December 2024");
  const [events, setEvents] = useState([]);
  const [hoveredEventId, setHoveredEventId] = useState(null);
  const [staffData, setStaffData] = useState([]);
  const [leaveData, setLeaveData] = useState(null)


  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await apiService.get("/staff_users");
        setStaffData(response.data);
      } catch (error) {
        console.error("fetching staff error", error);
      }
    };
    fetchStaff();
  }, []);


  useEffect(() => {
    const fetchLeaveData = async () => {
      try {
        const response = await apiService.get(`/leaves?staff_user_id=${staffId}`);
        setLeaveData(response?.data);
      } catch (errors) {
        handleError(errors)
      }
    };

    fetchLeaveData();
  }, []);

  useEffect(() => {
    if (!leaveData || !Array.isArray(leaveData)) return;

    const formattedEvents = [];

    leaveData.forEach((leave) => {
      const startDate = new Date(leave.from_date);
      const endDate = new Date(leave.to_date);

      for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
        formattedEvents.push({
          id: `${leave.id}-${date.toISOString().split("T")[0]}`,
          title: leave.leave_type === "sick" ? "Sick Leave" : "Casual Leave",
          start: new Date(date),
          end: new Date(date),
          allDay: true,
          backgroundColor: leave.leave_type === "sick" ? "#30b0c721" : "#f96b7c26",
          textColor: leave.leave_type === "sick" ? "#30B0C7" : "#F96B7C",
          borderColor: "transparent",
          // extendedProps: {
          //   reason: leave.reason || "No reason provided",
          //   checkIn: leave.check_in || "N/A",
          //   checkOut: leave.check_out || "N/A",
          // }
        });
      }
    });

    setEvents(formattedEvents);
  }, [leaveData]);

  const updateMonth = () => {
    const calendarApi = calendarRef.current.getApi();
    const currentDate = calendarApi.view.currentStart;
    setCurrentDate(new Intl.DateTimeFormat("en-US", { month: "long", year: "numeric" }).format(currentDate));
  };

  const handlePrev = () => {
    calendarRef.current.getApi().prev();
    updateMonth();
  };

  const handleNext = () => {
    calendarRef.current.getApi().next();
    updateMonth();
  };

  useEffect(() => {
    if (calendarRef.current) updateMonth();
  }, []);

  const eventContent = (eventInfo) => {
    const { event } = eventInfo;
    const initial = event.title?.charAt(0) || "?";
    const textColor = event.textColor || "#000";

    return (
      <div
        className="relative group w-full h-full flex justify-center items-center"
        onMouseEnter={() => setHoveredEventId(event.id)}
        onMouseLeave={() => setHoveredEventId(null)}
      >
        <div
          className="w-5 h-5 xs:w-8 xs:h-8 rounded-full flex items-center justify-center font-bold shadow-md text-base"
          style={{ backgroundColor: event.backgroundColor, color: textColor }}
        >
          {initial}
        </div>

        {hoveredEventId === event.id && (
          <div className="absolute bottom-full mb-2 px-3 py-1 bg-white text-G500 font-semibold text-xs rounded shadow-lg z-50 whitespace-nowrap">
            {event.title}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="w-full custom-calendar">
      <div className="bg-white h-auto rounded-2xl p-4  border border-[#5555581A] overflow-auto ">
        <h1 className="block lg:hidden text-xl xl:text-2xl text-G800 font-semibold mb-3">
          Attendance Calendar
        </h1>
        <div className="flex flex-col md:flex-row justify-between lg:items-center mb-7 gap-3 lg:gap-0">
          <div className="flex items-center gap-7 text-center">
            <h1 className="hidden lg:block text-xl xl:text-2xl text-G800 font-semibold">
              Attendance Calendar
            </h1>
            <div className="flex items-center gap-2">
              <button
                onClick={handlePrev}
                className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-green text-white flex justify-center items-center"
              >
                <icons.IoIosArrowBack />
              </button>
              <button
                onClick={handleNext}
                className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-green text-white flex justify-center items-center"
              >
                <icons.IoIosArrowForward />
              </button>
            </div>
            <h2 className="text-xl xl:text-2xl text-G800 font-semibold">
              {currentDate}
            </h2>
          </div>
          <div className="flex  justify-start gap-6 ">
          <div className="flex gap-2"><p className="w-5 h-5 rounded-full bg-[#30b0c721] text-[#30B0C7] flex justify-center items-center text-sm font-semibold">S</p><p className="text-xs sm:text-sm">Sick Leave</p> </div>
          <div className="flex gap-2"> <p className="w-5 h-5 rounded-full bg-[#f96b7c26] text-[#F96B7C] flex justify-center items-center text-sm font-semibold">C</p><p className="text-xs sm:text-sm">Causal Leave</p> </div>
        </div>
        </div>

        <FullCalendar
          ref={calendarRef}
          plugins={[dayGridPlugin]}
          initialView="dayGridMonth"
          headerToolbar={false}
          events={events}
          eventContent={eventContent}
        />
       
      </div>
    
    </div>
  );
}